import Icon from "../common/Icon";
import styles from "./Category.module.css";
import { CategoryOptions } from "../common/Common";

/**
 * 지도 영역 상단 카테고리 목록
 * @author mjkang
 * @since 2024-08-23 10:23:40
 * @param props {@link CategoryOptions}
 * @returns Category
 */
const Category = (props: CategoryOptions) => {
    const color = props.color ? props.color : "default";

    return (
        <div className={`${styles.wrapper} ${props.isActive ? styles.active : ""} ${props.disabled ? styles.disabled : ""}`} onClick={props.disabled ? undefined : props.onClick}>
            {props.icon && <Icon className={styles.icon} name={props.icon} size={"medium"} color={props.isActive ? "white" : color} />}
            {props.label && <span className={styles.label}>{props.label}</span>}
            {props.cancel && <Icon name="close" size={"small"} color={"white"} />}
        </div>
    );  
};

export default Category;